function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:.75px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_61",
  "data-name": "Group 61",
  transform: "translate(-27.232 -109.337)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_60",
  "data-name": "Group 60",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "prefix__Ellipse_18",
  cx: 2.421,
  cy: 2.42,
  className: "prefix__cls-1",
  "data-name": "Ellipse 18",
  rx: 2.421,
  ry: 2.42,
  transform: "rotate(-25.373 263.221 -5.482)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "prefix__Ellipse_19",
  cx: 2.782,
  cy: 2.782,
  r: 2.782,
  className: "prefix__cls-1",
  "data-name": "Ellipse 19",
  transform: "rotate(-25.373 264.048 -19.965)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_36",
  d: "M2118.595 1678.215a4.2 4.2 0 0 0-2.857-1.036 4.4 4.4 0 0 0-4.282 3.4",
  className: "prefix__cls-1",
  "data-name": "Path 36",
  transform: "translate(-2084.774 -1561.344)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_37",
  d: "M2121.3 1681.111a5.052 5.052 0 0 0-9.847-.024",
  className: "prefix__cls-1",
  "data-name": "Path 37",
  transform: "translate(-2078.646 -1561.855)"
})));

var SvgPassengers = function SvgPassengers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.874,
    height: 11.367,
    viewBox: "0 0 16.874 11.367",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassengers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/passengers.187fc7ad.svg";
export { ForwardRef as ReactComponent };